<form [formGroup]="dependantForm" (ngSubmit)="onSubmit()" class="grid gap-4 pt-2">
  <mat-form-field appearance="outline" class="w-full">
    <mat-label>Dependant type *</mat-label>
    <mat-select formControlName="dependantTypeId">
      <mat-option value="">Select dependant type</mat-option>
      @for (item of dependantTypes(); track item.id) {
        <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
      }
    </mat-select>
    @if (dependantForm.controls.dependantTypeId.hasError('required') && dependantForm.controls.dependantTypeId.touched) {
      <mat-error>Dependant type is required.</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-full">
    <mat-label>Title</mat-label>
    <mat-select formControlName="titleId">
      <mat-option value="">Select title</mat-option>
      @for (item of titles(); track item.id) {
        <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class="grid gap-4 sm:grid-cols-2">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>First name *</mat-label>
      <input matInput formControlName="firstName" />
      @if (dependantForm.controls.firstName.hasError('required') && dependantForm.controls.firstName.touched) {
        <mat-error>First name is required.</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Surname *</mat-label>
      <input matInput formControlName="surname" />
      @if (dependantForm.controls.surname.hasError('required') && dependantForm.controls.surname.touched) {
        <mat-error>Surname is required.</mat-error>
      }
    </mat-form-field>
  </div>

  <div class="grid gap-4 sm:grid-cols-2">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Date of birth</mat-label>
      <input matInput [matDatepicker]="dateOfBirthPicker" formControlName="dateOfBirth" />
      <mat-datepicker-toggle matIconSuffix [for]="dateOfBirthPicker"></mat-datepicker-toggle>
      <mat-datepicker #dateOfBirthPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Contact number</mat-label>
      <input matInput formControlName="contactNumber" />
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline" class="w-full">
    <mat-label>Email address</mat-label>
    <input matInput formControlName="emailAddress" type="email" />
    @if (dependantForm.controls.emailAddress.hasError('email') && dependantForm.controls.emailAddress.touched) {
      <mat-error>Enter a valid email address.</mat-error>
    }
  </mat-form-field>

  <button mat-raised-button color="primary" type="submit" [disabled]="saving()">
    Save dependant
  </button>
</form>
